import axios from "axios"
import LocalStorage from './local-storage'
import { TOKEN } from '../constants'

const HTTP = axios.create();

//interceptors for comunicate to services
HTTP.interceptors.request.use(
  (config) => {
    const tokenSession = LocalStorage.get(TOKEN);
    if (tokenSession) {
      config.headers["token-api"] = `${tokenSession}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

//interceptors for comunicate to services
HTTP.interceptors.response.use(
  (response) => response.data,
  (error) => {
    if(axios.isCancel(error)) return;
    
    const { status } = error.response;
    if (status === 401) {
        LocalStorage.clear();
        window.location.replace('/auth/login');
    }
    return Promise.reject(error.response.data);
  }
);

export default HTTP;
